/**
 * Boot deadline (#126) — 15s max spinner; escape hatch at 3s; no false fire on slow success.
 */
import { hasReachedUsableAuthedState, isBootTimeTerminalRejection } from './authTerminalLatch';

export const BOOT_DEADLINE_MS = 15_000;
export const BOOT_ESCAPE_HATCH_MS = 3_000;
/** Grep production bundle to verify the 15s boot deadline shipped. */
export const BOOT_DEADLINE_MARKER = 'boot_deadline_15s_v1';

const BOOT_PROGRESS_GRACE_MS = 8_000;

let bootProgressAt: number | null = null;
let bootSurrendered = false;
let backgroundBootActive = false;
let stallGate: (() => boolean) | null = null;

export function registerBootDeadlineStallGate(gate: () => boolean): void {
  stallGate = gate;
}

export function noteBootAuthProgress(): void {
  bootProgressAt = Date.now();
}

export function markBootSurrendered(stillConnecting = false): void {
  bootSurrendered = true;
  backgroundBootActive = stillConnecting;
}

export function clearBootSurrendered(): void {
  bootSurrendered = false;
  backgroundBootActive = false;
}

export function isBootSurrendered(): boolean {
  return bootSurrendered;
}

export function isBootBackgroundConnecting(): boolean {
  return backgroundBootActive;
}

/** True when the hard deadline may fire (stalled boot — not slow healthy restore). */
export function shouldApplyBootDeadline(nowMs = Date.now()): boolean {
  if (hasReachedUsableAuthedState()) return false;
  if (isBootSurrendered()) return false;
  if (isBootTimeTerminalRejection()) return false;
  if (stallGate?.()) return true;
  if (bootProgressAt && nowMs - bootProgressAt < BOOT_PROGRESS_GRACE_MS) return false;
  return true;
}

export function resetBootDeadlineForTests(): void {
  bootProgressAt = null;
  bootSurrendered = false;
  backgroundBootActive = false;
  stallGate = null;
}
